import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useLanguage } from "@/contexts/LanguageContext";
import { useDomain } from "@/hooks/useDomain";

const SESSION_KEY = "mdt-session-id";

const getSessionId = () => {
  try {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
      id =
        (crypto?.randomUUID?.() ||
          `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`);
      localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return "anon";
  }
};

// Detect a service-detail page and extract the slug so the backend can roll up
// "Top Service Pages" without parsing paths server-side.
const SERVICE_PATH_RE = /^\/services\/([a-z0-9-]+)/i;

const PageviewTracker = () => {
  const location = useLocation();
  const { locale } = useLanguage();
  const domain = useDomain();
  const lastSent = useRef("");

  useEffect(() => {
    // Skip the admin area — we don't want internal traffic skewing the stats.
    if (location.pathname.startsWith("/admin")) return;

    const key = `${location.pathname}${location.search}`;
    if (key === lastSent.current) return;
    lastSent.current = key;

    const match = SERVICE_PATH_RE.exec(location.pathname);
    const payload = {
      path: location.pathname,
      domain: domain.hostname,
      locale,
      referrer: document.referrer ? new URL(document.referrer).host.slice(0, 256) : "",
      session: getSessionId(),
      service_slug: match ? match[1] : null,
    };
    api.post("/track/pageview", payload).catch(() => {
      /* swallow – tracking must never break the UX */
    });
  }, [location.pathname, location.search, locale, domain.hostname]);

  return null;
};

export default PageviewTracker;
